<script setup lang="ts">
import { KsDialogTitle } from '@aschehoug/kloss-2'
</script>

<template>
  <KsDialogTitle class="dialog-title">
    <slot />
  </KsDialogTitle>
</template>

<style lang="scss" scoped>
  .dialog-title {
    color: var(--color-yellow-10);
    margin: 0;
    font-weight: 600;
  }
</style>
